import { createFileRoute, redirect } from "@tanstack/react-router";
import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { salesAgentQueryOptions } from "@/core/components/sales-agents/salesAgentQueryOptions";

export const Route = createFileRoute(
	"/_layout/dashboard/sales-agents/$agentId/edit/",
)({
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (auth.user?.role !== Role.Internal) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	loader: ({ context: { queryClient, auth }, params: { agentId } }) =>
		queryClient.ensureQueryData(salesAgentQueryOptions(agentId, auth.token!)),
	errorComponent: ErrorComponent,
	pendingComponent: LoadingList,
});
